<template>
    <div :id="this.$route.name">
        <card back>
            <template v-slot:header>
                <h4 class="d-inline">لیست فیش های حقوقی</h4>
                <hr />
            </template>
            <template v-slot:content>
                <div class="row"></div>
                <BnpGrid v-if="$store.state.renderComponentGrid"  :propsColumn="Column"  :propsRows="rows" :action="true" :hasRowNum="true" :Sortable="true" >
                        <template slot="action-slot" slot-scope="props">
                           <button class="btn btn-sm btn-success" @click="GetFish(props.props)">فیش حقوقی </button> 
                        </template>
                    </BnpGrid>
            </template>
            </card> 
    </div>
</template>
<script>
import Card from '@/components/Card/Card.vue';
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
export default {
    data() {
        return {
            NameFam:'', 
            WorkShopName:'',
            PersonnelCode:0,
            personelId:0,
            rows:[],
            Column:[
                {
                name: 'Id',
                label: 'Id',
                visibility: false,
                },
                {
                name: 'Year',
                label: 'سال',
                visibility: true,
                },
                {
                name: 'Month',
                label: 'ماه',
                visibility: true,
                },
                {
                name: 'WorkPerformanceDaily',
                label: 'کارکرد',
                visibility: true,
                },
                {
                name: 'TotalPayment',
                label: 'پرداختی',
                visibility: true,
                },
                {
                name: 'DeductionsSum',
                label: 'کسورات',
                visibility: true,
                },
                {
                name: 'NetPayment',
                label: 'خالص پرداختی',
                visibility: true,
                },

            ],
        };
    },
    components:{Card,BnpGrid},
    mounted(){
        this.GetData()
    },
    methods:{
        GetData(){
            var DataAxois={
                ArryfildValue:{},Method: 'Get',Action: 'Personnel/GetPersonelFishByUserId',Token: this.$session.get('Token'),
            }
            this.$PostData(DataAxois).then((data) => {
                if(data!=null){
                    if(data.IsSuccess==true){
                        // console.log(data);
                        for (let index = 0; index < data.Data.length; index++) {
                            const element =  data.Data[index];
                            for (let j = 0; j < element.SalaryDetails.length; j++) {
                                const item = element.SalaryDetails[j];
                                this.rows.push(item)
                            }
                            
                        }
                    }
                }
          }).finally(() => {
                this.$store.state.renderComponentGrid = false
                this.$nextTick(() => {
                this.$store.state.renderComponentGrid = true
                })
            });
        },
        GetFish(data){
            var DataAxois={
                ArryfildValue:{},Method: 'Get',Action: 'SalaryReport/GetFish/'+data.Id,Token: this.$session.get('Token'),
            }
            this.$PostData(DataAxois).then((data) => {
                if(data!=null){
                    if(data.IsSuccess==true && data.Data!=null){
                        // console.log(data.Data);
                        this.$router.push({ name: 'FishPrint' , params: {DataRow: data.Data, Status: 'Single'} })
                    }
                }
            })
        }
    }

}

</script>
<style scoped>
</style>